const middleware = {}

middleware['router-guard'] = require('../src/middleware/router-guard.js')
middleware['router-guard'] = middleware['router-guard'].default || middleware['router-guard']

export default middleware
